import * as React from 'react';
import { useSelector } from 'react-redux';
import { withProvider } from '../../redux';
import { selectConfigValue } from '../../selectors/config';
import { selectLocationsFromAddress } from '../../selectors/offer';
import { ApplicationContext } from '../ApplicationContext';
import { Device } from '../common/Device';
import { HAS_BEEN_CLOSED_MARK } from './constants';
import { MLSNPublicationBannerDesktop, MLSNPublicationBannerMobile } from './components';
import { IMLSNPublicationBannerContainerProps } from './types';

export const MLSNPublicationBannerContainer = () => {
  const locations = useSelector(selectLocationsFromAddress);
  const mlsnPublicationBannerLocations = useSelector(selectConfigValue('mlsnPublicationBannerLocations'));

  const isRequiredLocation = mlsnPublicationBannerLocations.some(location => locations.includes(location));

  const [isClosed, setIsClosed] = React.useState(() => !!sessionStorage.getItem(HAS_BEEN_CLOSED_MARK));

  const isVisible = isRequiredLocation && !isClosed;

  const handleCloseClick = React.useCallback(() => {
    sessionStorage.setItem(HAS_BEEN_CLOSED_MARK, '1');
    setIsClosed(true);
  }, [isClosed]);

  if (!isVisible) {
    return null;
  }

  return (
    <Device
      desktop={<MLSNPublicationBannerDesktop handleCloseClick={handleCloseClick} />}
      mobile={<MLSNPublicationBannerMobile handleCloseClick={handleCloseClick} />}
    />
  );
};

export const MLSNPublicationBannerWrapper = withProvider((props: IMLSNPublicationBannerContainerProps) => {
  const { httpApi, logger, config, telemetry } = props;

  const context = React.useMemo(() => ({ httpApi, logger, config, telemetry }), [httpApi, logger, config, telemetry]);

  return (
    <ApplicationContext.Provider value={context}>
      <MLSNPublicationBannerContainer />
    </ApplicationContext.Provider>
  );
});
